import { CompositionChildEditPreviewDto } from '@app/modules/compose/composition.types';

/**
 * Returns a child edit's public thumbnail URL when the API value is a non-empty string.
 * OpenAPI types `thumbnailUrl` as object; runtime value is a URL string.
 */
export function getCompositionEditThumbnailSrc(
  edit: CompositionChildEditPreviewDto,
): string | null {
  const url: unknown = edit.thumbnailUrl;
  if (typeof url === 'string' && url.length > 0) {
    return url;
  }
  return null;
}
